import { useEffect, useState } from "react";

const ImageSlider = ({ images }: { images: string[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const imageCount = images?.length || 1;
  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % imageCount);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + imageCount) % imageCount);

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [imageCount]);

  return (
    <div className='image-slider'>
      <button className='slider-arrow left' onClick={prevSlide}>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#333' strokeWidth='1.8'>
          <polyline points='15 18 9 12 15 6' />
        </svg>
      </button>

      {images?.length > 0 ? (
        <img src={images[currentIndex]} alt='product' className='product-image' />
      ) : (
        <div className='slider-skeleton-image'></div>
      )}

      <button className='slider-arrow right' onClick={nextSlide}>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#333' strokeWidth='1.8'>
          <polyline points='9 18 15 12 9 6' />
        </svg>
      </button>
    </div>
  );
};

export default ImageSlider;